module.exports = __webpack_public_path__ + "static/media/silvasa1.78541b56.webp";